<template>
<section class="notice_view">
    <div class="wrap">
        <div class="notice_view_info">
            <p></p>
            <span>2021-10-01</span>
        </div>
    </div>

    <div class="notice_contents">
        <strong style="font-size:15px;">제1조 (목적)</strong><br><br>
        이 약관(이하 “약관”이라고 한다)은 (주)그리트라운지(이하 “회사”라고 한다)가 제공하는 “서비스”의 이용과 관련하여 “회사”와 “회원”간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 한다.<br>

        <br>

        <strong style="font-size:15px;">제2조 (정의)</strong><br><br>
        "약관"에서 사용하는 용어의 정의는 아래와 같습니다.<br><br>
        (1) “서비스”라 함은 “회사”에서 제공하는 온•오프라인상의 제반 서비스를 의미합니다.<br><br>
        (2) “회원”이라 함은 본 약관에 따라 “회사”와 이용 계약을 체결하고, “회사”가 제공하는 서비스를 이용할 수 있는 권한을 부여 받은 고객을 말합니다.<br><br>
        (3) "사업자회원"이라 함은 “회사”의 "서비스"를 이용하여 “회원”에게 상품, 용역, 서비스 등을 제공하는 사업자를 의미합니다.<br><br>
        (4) “게시물”이라 함은 “회원” 및 “사업자회원”이 “서비스”에 게시 또는 등록하는 부호(URL 포함), 문자, 음성, 음향, 영상(동영상 포함), 이미지(사진 포함), 파일 등을 말합니다.<br><br>
        (5) 본 조에서 정의되지 않은 “약관”상의 용어의 의미는 일반적인 거래관행을 따릅니다.<br>

        <br>

        <strong style="font-size:15px;">제3조 (약관의 게시와 개정)</strong><br><br>
        (1) "회사"는 "약관"의 내용을 “회원”이 쉽게 알 수 있도록 회원이 이용하는 “서비스”의 초기 화면 또는 연결 화면을 통하여 게시합니다.<br><br>
        (2) "회사"는 필요한 경우 관련 법령을 위배하지 않는 범위 내에서 "약관"을 개정할 수 있습니다.<br><br>
        (3) "회사"는 "약관"을 개정할 경우 개정내용과 적용일자를 명시하여 제9조에 따른 방법으로 적용일자 7일 전부터 적용일자 전일까지 통지합니다. 다만, “회원”에게 불리하게 개정되는 경우에는 적용일자 30일 전부터 적용일자까지 공지하고, “회원”이 기재한 전자우편주소 또는 “서비스”의 화면을 활용한 전자적 수단을 통해 별도로 통지합니다.<br><br>
        (4) “회원”이 명시적으로 거부의 의사표시를 하지 않은 경우 “회원”은 개정되는 "약관"에 동의한 것으로 간주합니다.<br><br>
        (5) “회원”은 "약관"의 개정에 동의하지 않을 경우 적용일자 전일까지 "회사"에 거부의사를 표시하고 “서비스” 이용계약을 해지할 수 있습니다.<br>

        <br>

        <strong style="font-size:15px;">제4조 (약관의 해석)</strong><br><br>
        (1) “회사”는 개별 서비스에 대해서는 별도의 약관(이하 “개별약관”) 및 정책(이하 “개별정책”)을 둘 수 있으며, 해당 내용이 본 “약관”과 충돌할 경우에는 “개별약관” 및 “개별정책”이 우선하여 적용됩니다.<br><br>
        (2) 본 “약관”에 명시되지 않은 사항에 대해서는 “약관”의 규제에 관한 법률, 전자문서 및 전자거래 기본법, 전자서명법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 전자상거래 등에서의 소비자보호에 관한 법률 등 관계 법령 또는 상관례에 따릅니다.<br>

        <br>

        <strong style="font-size:15px;">제5조 (회원가입 및 계약의 성립)</strong><br><br>
        (1) “회사”의 “회원”이 되고자 하는 자(이하 “가입신청자”)는 “회사”가 정한 회원가입 절차에 의해 본 “약관”과 별도의 “개별약관”에 대하여 동의한 다음 회원가입을 신청하고, “회사”가 이러한 신청에 대하여 승낙함으로써 회원가입이 성립됩니다. <br><br>
        (2) “회사”는 “가입신청자”의 회원가입 신청에 대하여 “서비스” 이용을 승낙함을 원칙으로 합니다. 다만, “회사”는 다음 각 호에 해당하는 회원가입 신청에 대하여는 승낙을 하지 않거나, 사후에 회원가입 계약을 해지할 수 있습니다.<br><br>
        1. “가입신청자”가 본 약관에 의하여 이전에 “회원” 자격을 상실한 적이 있는 경우, 단 “회사”의 “회원” 재가입 승낙을 얻은 경우에는 예외로 함<br>
        2. “가입신청자”의 실명이 아니거나, 타인의 명의를 이용한 경우 <br>
        3. “회사”가 제시하는 내용을 기재하지 않았거나, 허위의 정보를 기재한 경우 <br>
        4. “가입신청자”의 귀책 사유로 인하여 승인이 불가능하거나, 기타 규정한 제반 사항을 위반하며 신청하는 경우<br>
        (3) 회원가입의 성립 시기는 “회사”가 회원가입 완료를 신청 절차 상에서 표시한 시점으로 합니다.<br><br>
        (4) “회사”는 “회원”에 대해 개별정책에 따라 “서비스” 이용에 차등을 둘 수 있습니다.<br><br>
        (5) “회사”는 “서비스” 관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다.<br><br>
        (6) 제1항에 따른 신청에 있어 “회사”는 “가입신청자”의 동의를 얻어 개인정보나 신용정보를 수집, 이용 또는 신용조회회사 등에 제공하거나 받을 수 있습니다.<br>

        <br>

        <strong style="font-size:15px;">제6조 (회원정보 등의 변경)</strong><br><br>
        (1) “회원”은 서비스의 회원정보 관리화면을 통하여 언제든지 본인의 회원정보를 열람할 수 있으며, 이를 수정할 수 있습니다.<br><br>
        (2) “회원”은 회원가입신청 시 기재한 사항이 변경되었을 경우, 회원정보 관리화면을 통하여 수정을 하거나 전화, 전자우편 기타 방법으로 "회사"에 대하여 그 변경사항을 알려야 합니다.<br><br>
        (3) “회원”이 제2항을 위반하여 변경사항을 "회사"에 알리지 않아 발생한 불이익에 대해서 "회사"는 책임지지 않습니다.<br>

        <br>

        <strong style="font-size:15px;">제7조 (서비스 이용의 제한)</strong><br><br>
        (1) “회사”는 “회원”이 “서비스”의 본래 목적에 어긋나게 이를 사용하거나 또는 “사업자회원”의 사업을 방해할 목적으로 “서비스”를 이용하는 경우 등에는 “서비스” 이용을 제한할 수 있습니다.<br><br>
        (2) “회사”는 원칙적으로 “회원”의 이용신청을 승낙한 때로부터 “서비스”를 연중무휴로 제공합니다. 다만, “회사”의 기술상 또는 업무상의 장애로 인하여 “서비스”를 즉시 개시하지 못하는 경우 “회사”는 제9조에 따른 방법으로 “이용자”에게 통지합니다.<br><br>
        (3) “회사”는 안정적인 “서비스” 제공을 위하여 “서비스”의 내용, 운영상 또는 기술상 사항 등을 변경할 수 있습니다. 이 경우 “회사”는 “서비스” 중요사항을 변경할 경우 변경내용과 적용일자를 명시하여 제9조에 따른 방법으로 사전에 통지합니다.<br><br>
        (4) “회사”는 다음 각 호에 해당하는 경우 “서비스”의 일부 또는 전부의 제공을 일시적으로 중단할 수 있습니다. 이 경우 “회사”는 “서비스” 이용의 중단 사실을 제9조의 방법에 따라 즉시 공지합니다.<br><br>
        1. 설비의 보수 등을 위하여 부득이한 경우<br>
        2. 「전기통신사업법」에 규정된 기간통신사업자가 전기통신서비스를 중지하는 경우<br>
        3. 국가비상사태, 정전, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 정상적인 “서비스” 제공에 지장이 있는 경우<br>
        4. 기타 “회사”가 “서비스”를 제공할 수 없는 위 제1호 내지 제3호에 준하는 사유가 발생한 경우<br>
        5. “사업자회원”이 “회사”가 제공하는 통상적인 수준의 트래픽, 용량 등을 과도하게 초과하여 “회사”의 정상적인 “서비스” 제공에 지장을 초래할 우려가 있는 경우<br>

        <br>

        <strong style="font-size:15px;">제8조 (회원의 탈퇴 및 자격상실)</strong><br><br>
        (1) “회원”은 언제든지 “서비스”를 이용하며 회원탈퇴를 요청할 수 있으며, “회사”는 관련법 등이 정하는 바에 따라 이를 수일 내에 처리하여야 합니다.<br><br>
        (2) “회원”의 요청으로 인하여 회원탈퇴 요청이 처리되는 경우, “회사”가 보유하고 있는 회원의 개인 정보는 즉시 삭제됩니다. 단, 다음 각 호의 어느 하나에 해당하는 경우 탈퇴 처리가 거절될 수 있습니다.<br><br>
        1. “회원”이 회사에 대한 금전적인 채무가 존재하는 경우<br>
        2. 사고처리 등과 같이 “회원”의 책임있는 행위를 기반으로 업무 처리가 완료되지 않은 경우<br><br>
        (3) “회원”의 요청으로 인한 회원탈퇴 시 3개월간 “회원” 재가입 신청이 제한됩니다. 단, “회사”와 “회원” 간에 사전 협의한 경우에는 회원 재가입이 가능합니다.<br><br>
        (4) “회원”이 다음 각 호의 어느 하나에 해당하는 경우, “회사”는 회원 자격을 상실시킬 수 있습니다.<br><br>
        1. 회원정보 입력 시 허위 내용을 기입한 경우<br>
        2. 비정상적인 방법으로 다른 사람의 “서비스 “이용을 방해하거나, 허위 및 거짓 제보를 통해 “서비스”의 정상적인 운영을 지속 저해하는 경우<br>
        3. 다른 사람의 정보를 불법적으로 취득하거나 도용하는 경우<br>
        4. 관계법령에 위반되거나 공서양속에 반하는 행위를 하는 등 “회원” 자격을 유지시키는 것이 부적절하다고 판단되는 경우<br><br>
        (5) “회원”은 제4항에 따른 자격상실에 대해 “회사”가 정한 절차에 따라 이의신청을 할 수 있으며, “회사”는 “회원”의 이의신청이 정당하다고 판단되는 경우 즉시 회원 자격을 재개합니다.<br>

        <br>

        <strong style="font-size:15px;">제9조 (통지)</strong><br><br>
        (1) “회사”가 “회원”에 대하여 통지를 하는 경우 “약관”에 별도의 규정이 없는 한 “회원”이 제공한 전자우편주소, (휴대)전화번호, 주소 등으로 할 수 있습니다.<br><br>
        (2) “회사”는 “회원” 전체에 대하여 통지를 하는 경우 “서비스”의 초기화면 또는 게시판 등에 게시함으로써 전항의 통지에 갈음할 수 있습니다. 다만, “회원”의 “서비스” 이용에 중대한 영향을 주는 사항에 대해서는 전항의 통지 수단 중 2개 이상의 방법으로 통지합니다.<br><br>
        (3) “회원”은 “회사”에 실제로 연락이 가능한 전자우편, (휴대)전화번호, 주소 등의 정보를 제공하고 해당 정보들을 최신으로 유지하여야 하며, “회사”의 통지를 확인하여야 합니다.<br>

        <br>

        <strong style="font-size:15px;">제10조 (리뷰)</strong><br><br>
        (1) “회원”은 “서비스”를 통해 예약이나 주문 후 이용한 상품 및 서비스 등의 리뷰를 등록할 수 있으며, 리뷰의 저작권은 당 리뷰의 저작자에게 귀속합니다.<br><br>
        (2) 리뷰의 등록으로 인해 저작권 침해 등 “회원”과 제3자 사이에 분쟁이 발생하는 경우 이와 관련한 일체의 책임은 해당 리뷰를 등록한 “회원”에게 있습니다.<br><br>
        (3) “회사”는 “회원”이 등록한 리뷰가 다음 각 호에 해당한다고 판단되는 경우 사전 통보 없이 해당 리뷰를 삭제하거나 열람을 제한할 수 있으며, “회원”의 “서비스” 이용을 중지 또는 해지 할 수 있습니다.<br><br>
        1. 타인의 권리나 명예, 신용, 기타 정당한 이익을 침해하는 경우<br>
        2. 사회 공공질서나 미풍양속에 위배되는 경우<br>
        3. 범죄행위와 관련된 내용을 포함하는 경우<br>
        4. 허위 또는 과장 광고 내용을 포함하는 경우<br>
        5. 불법물, 음란물 또는 청소년유해매체물의 게시, 등록 또는 이와 관련된 물품의 홍보, 사이트를 링크하는 등의 경우<br>
        6. 정보통신기기의 오작동을 일으킬 수 있는 악성코드나 데이터를 포함하는 경우<br>
        7. 관련 법령에서 정하거나 정당한 권한을 가진 정부기관 등의 요청 등이 있는 경우<br>
        8. "서비스" 이용 사실 없이 작성하였거나, "서비스" 또는 "상품 등"의 이용과 무관한 내용을 포함하는 등으로 인해 "서비스"의 본래 목적에 어긋나는 경우<br>
        9. "회사"가 제공하는 "서비스"의 원활한 진행을 방해하는 것으로 판단되는 경우<br><br>
        (4) “회사”는 리뷰를 검색결과나 프로모션 등 “서비스”(제휴서비스를 통한“서비스”의 노출을 포함)와 관련된 목적 범위 내에서 무상으로 사용할 수 있으며, “회사”의 사용목적에 따라 필요한 범위 내에서 일부 수정, 복제, 편집하여 사용할 수 있습니다.단, “회원”은 언제든지 고객센터 및 신고하기 등을 통해 해당 게시물에 대해 삭제, 비공개 등의 조치를 요청할 수 있습니다.<br>

        <br>

        <strong style="font-size:15px;">제11조 (회사의 의무)</strong><br><br>
        (1) “회사”는 관련법과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 “서비스”를 제공하기 위하여 최선을 다하여 노력합니다.<br><br>
        (2) “회사”는 “회원”이 안전하게 “서비스”를 이용할 수 있도록 개인정보보호를 위해 보안시스템을 갖추어야 하며 개인정보처리방침을 공시하고 준수하며, 회원의 개인정보를 본인의 승낙 없이 제3자에게 누설, 배포하지 않고, 이를 보호하기 위하여 노력합니다.<br><br>
        (3) “회사”는 “서비스” 이용과 관련하여 “회원”으로부터 제기된 의견이나 불만이 정당하다고 인정할 경우에는 그에 필요한 조치를 취하여야 합니다.<br>

        <br>

        <strong style="font-size:15px;">제12조 (회원의 의무)</strong><br><br>
        (1) “회원”은 기타 관계 법령, 본 약관의 규정, 이용안내 및 서비스상에 공지한 주의사항, “회사”가 통지하는 사항 등을 준수하여야 하며, 기타 “회사”의 업무에 방해되는 행위를 하여서는 아니 됩니다.<br><br>
        (2) “회원”은 “서비스”의 이용권한, 기타 서비스 이용계약상의 지위를 타인에게 양도, 증여할 수 없으며 이를 담보로 제공할 수 없습니다.<br>

        <br>

        <strong style="font-size:15px;">제13조 (책임제한)</strong><br><br>
        (1) “회사”는 천재지변, 디도스(DDOS) 공격, IDC 장애, 기간통신사업자의 회선 장애 및 기타 이에 준하는 불가항력으로 인하여 “서비스”를 제공할 수 없는 경우에는 “서비스” 제공에 관한 책임이 면제됩니다. <br><br>
        (2) “회사”는 “회원” 또는 “사업자회원”의 귀책사유로 “서비스” 이용 중 장애가 발생한 경우 책임을 지지 않습니다.<br><br>
        (3) “회사”는 “회원” 또는 “사업자회원”이 “서비스”를 이용하여 기대하는 손익이나 “서비스”를 통하여 얻은 자료로 인해 발생한 손해에 대하여 “회사”의 귀책사유가 없는 한 책임을 지지 않습니다. <br><br>
        (4) “회사”는 “회원” 또는 “사업자회원”이 서비스에 게재한 정보, 자료, 사실의 신뢰도, 정확성에 대하여 “회사”의 고의 또는 중대한 과실이 없는 한 책임을 지지 않습니다. <br><br>
        (5) “회사”는 “회원”간 또는 “회원”과 제3자 상호간에 서비스를 매개로 하여 거래 등을 한 경우에는 책임을 지지 않습니다. <br><br>
        (6) 링크 등으로 연결된 사이트를 운영하는 회사(이하 “피연결회사”)는 “회사”와 별개의 사업자로서 독자적으로 운영됩니다. “회사”는 “회원”과 피연결회사 간에 이루어진 일체의 거래에 대해서 어떠한 책임도 지지 않습니다. <br><br>
        (7) “회원”이 “서비스”를 이용함에 있어 행한 불법행위나 본 약관상 위반행위로 인하여 “회사”가 해당 “회원” 이외의 제3자로부터 손해배상 청구 또는 소송을 비롯한 각종 이의제기를 받는 경우, 해당 “회원”은 자신의 책임과 비용으로 “회사”를 면책시켜야 하며, 그로 인하여 “회사”에 발생한 모든 손해를 배상하여야 합니다.<br>

        <br>

        <strong style="font-size:15px;">제14조 (준거법 및 재판 관할)</strong><br><br>
        (1) “회사”와 “회원”간 제기된 소송은 대한민국법을 준거법으로 합니다.<br><br>
        (2) “회사”와 “회원” 간 분쟁이 발생한 경우 “회원”의 주소지를 관할하는 법원을 관할법원으로 하며, “회원”의 주소 또는 거소가 명확하지 않을 경우 관할법원은 민사소송법에 따라 정합니다. 단, “회원”의 책임있는 사유로 채권채무가 발생한 경우 그 관리업무를 담당하는 회사 사무소 소재지의 지방법원을 관할법원으로 합니다.<br>

        <br>

        <strong style="font-size:15px;">[부칙]</strong><br><br>
        (1) 본 약관은 2021년 10월 01일부터 적용됩니다.



    </div>
</section>
</template>

<script>
    export default {
        name:'NoticeInfo',
        created () {
            this.$store.state.headerTitle = '서비스 이용 약관';
            this.$store.commit('SHOW_ONLOAD');
        },
    }
</script>

<style lang="scss" scoped>

</style>